// Search.tsx
import React, { useState } from 'react';
import { styled, InputBase, Tooltip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

// Import CircularButton from AccountActions
import { CircularButton } from '../common/AccountActions'; // Adjust the path accordingly

const SearchContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  borderRadius: '40px',
  border: '2px solid #000000de',
  padding: '0px',
  transition: 'border-color 0.3s',
  '&:focus-within': { borderColor: '#e78758' },
});

const SearchInput = styled(InputBase)({
  width: '100%',
  padding: '4px 30px 4px 8px',
});

const SearchButton = styled(CircularButton)<{ isSearchFocused: boolean }>(({ isSearchFocused }) => ({
  backgroundColor: isSearchFocused ? '#e78758' : '#fff',
  transition: 'background-color 0.3s',
  marginRight: '0px',
  '&:hover, &:focus': { backgroundColor: '#e78758' },
}));

const SearchIconStyled = styled(SearchIcon)({ color: '#000000de', fontSize: 30 });

const Search: React.FC<{ onSearch: (query: string) => void }> = ({ onSearch }) => {
  const [isSearchFocused, setIsSearchFocused] = useState(false);

  return (
    <SearchContainer>
      <SearchInput
        placeholder="Search for toys"
        inputProps={{ 'aria-label': 'search' }}
        onChange={(e) => onSearch(e.target.value)}
        onFocus={() => setIsSearchFocused(true)}
        onBlur={() => setIsSearchFocused(false)}
      />
      <Tooltip title="Search" arrow placement="top">
        <SearchButton isSearchFocused={isSearchFocused}>
          <SearchIconStyled />
        </SearchButton>
      </Tooltip>
    </SearchContainer>
  );
};

export default Search;